import { refreshTokenNew } from '../../utils/helper';
import Footer from './Footer/footer';
import Header from './Header/header';
function DashboardLayout({ children }) {
  refreshTokenNew();
  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  );
}

export default DashboardLayout;
